module.exports = __webpack_public_path__ + "img/561.280e0c1b.jpg";